export default "__VITE_ASSET__23b1c938__"